import { matchPath, useLocation, useNavigate } from 'react-router-dom'
import { match } from 'ts-pattern'
import { useSetAtom } from 'jotai'

import { automationsPaths } from 'Automations/router'
import { watchtowerFiltersAtom } from 'Automations/watchtower/atoms'
import { ListView } from '../inbox.types'

type UseCurrentListView = () => {
  currentView: ListView
  setCurrentView: (newView: ListView) => void
}

export const useCurrentListView: UseCurrentListView = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const setFilters = useSetAtom(watchtowerFiltersAtom)
  const isAllRoute = matchPath(
    {
      path: automationsPaths.executionInbox(),
      end: false
    },
    location.pathname
  )

  return {
    currentView: isAllRoute ? 'all' : 'needsAction',
    setCurrentView: (newView: ListView) => {
      // Clear the status filter when switching to "Needs Action", which pins
      // the status to PENDING and so cannot honour a selected status.
      if (newView === 'needsAction') {
        setFilters(prev => ({ ...prev, status: [] }))
      }
      const path = match(newView)
        .with('all', () => automationsPaths.executionInbox())
        .with(
          'needsAction',
          () => `${automationsPaths.manualTasksInbox()}/tasks`
        )
        .exhaustive()
      navigate(path)
    }
  }
}
